module.exports = __webpack_public_path__ + "static/media/loader.aefc4189.svg";